import { render, staticRenderFns } from "./AdminsNew.vue?vue&type=template&id=4c3fe136&"
import script from "./AdminsNew.vue?vue&type=script&lang=ts&"
export * from "./AdminsNew.vue?vue&type=script&lang=ts&"
import style0 from "./AdminsNew.vue?vue&type=style&index=0&id=4c3fe136&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports